export default ["dev","about.html","assessment-auto.html","contacts.html","dogovoru.html","error-404.html","faq.html","helpful-information.html","index.html","news-inner-2.html","news-inner.html","partner.html","politika.html","reviews.html","service.html","success-page.html"]


// WEBPACK FOOTER //
// app/scripts/files.js